import { Box, Typography, Container, Grid, Button, Tab, Tabs, Pagination } from '@mui/material';
import HomeLayout from 'layouts/HomeLayout';

import { getPageContent } from 'context/actions/pages';
import { getNewsContent, getNewsList } from 'context/actions/news';
import i18n from 'i18next';
import { useTranslation } from 'react-i18next';
import Link from 'next/link';
import { GlobalContext } from 'context';
import NewsItemList from 'components/NewsItemList';

// components
import WysiwygViewer from 'components/TextEditorViewer';
import { useEffect, useState, useContext } from 'react';
import { types } from 'constants/data/newsTypes';

const NewsList = ({ type }) => {
    const { t } = useTranslation();

    const { state } = useContext(GlobalContext);
    const [news, setNews] = useState([]);
    const [meta, setMeta] = useState(null);
    const [page, setPage] = useState(1);

    useEffect(() => {
        // getPage();
        getNews();
    }, [type, page]);

    const getNews = async () => {
        const res = await getNewsList('', page, 10, type);
        console.log('NESLIST', res);
        if (res.status === 'success') {
            setNews(res.data.list);
            setMeta(res.data.meta);
        }
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    return (
        <Container
            maxWidth="lg"
            style={{
                paddingBottom: 16,
                paddingTop: 120,
            }}
        >
            <Grid container spacing={4} direction={'row'}>
                <Grid item lg={8} md={6} sm={12} xs={12}>
                    <Typography
                        variant={'h2'}
                        style={{ fontSize: 20, marginBottom: 20, marginTop: 0 }}
                    >
                        {i18n.language === 'en'
                            ? types.find((item) => item.code === type)?.nameEng
                            : types.find((item) => item.code === type)?.name}
                    </Typography>
                    {news.map((item, ind) => {
                        return (
                            <NewsItemList
                                key={ind}
                                newsId={item.id}
                                imageUrl={item.imageUrl}
                                date={item.createdAtDayString}
                                name={i18n.language === 'en' ? item.nameEng : item.name}
                                typeName={
                                    i18n.language === 'en'
                                        ? types.find((i) => i.code === type)?.nameEng
                                        : types.find((i) => i.code === type)?.name
                                }
                                description={
                                    i18n.language === 'en' ? item.descriptionEng : item.description
                                }
                                last={news.length === ind + 1 ? true : false}
                                seenCount={item.seenCount}
                            />
                        );
                    })}
                    {meta && (
                        <Box className="flex flex-row justify-center p-6">
                            <Pagination
                                count={Math.ceil(meta.total_count / meta.limit)}
                                page={meta.current_page}
                                variant="outlined"
                                shape="rounded"
                                onChange={handleChangePage}
                            />
                        </Box>
                    )}
                </Grid>
                <Grid item lg={4} md={6} sm={12} xs={12}>
                    <Box
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            backgroundColor: '#fbf9ff',
                            padding: '40px 20px',
                        }}
                    >
                        <Typography variant={'h2'} style={{ fontSize: 20 }}>
                            {t('news_type')}
                        </Typography>
                        <Box
                            style={{
                                borderBottom: '1px solid',
                                borderBottomColor: '#f0e9ff',
                                height: 1,
                                width: '100%',
                            }}
                            className={'mt-2 mb-8'}
                        ></Box>
                        {types.map((tp, ind) => {
                            return (
                                <>
                                    <Link href={'/newsList/' + tp.code} passHref>
                                        <Typography
                                            key={ind}
                                            variant={'h3'}
                                            style={{
                                                color: '#888888',
                                                cursor: 'pointer',

                                                '&:hover': {
                                                    color: 'blue',
                                                },
                                            }}
                                        >
                                            {i18n.language === 'en' ? tp.nameEng : tp.name}
                                        </Typography>
                                    </Link>

                                    {types.length - 1 !== ind && (
                                        <Box
                                            style={{
                                                borderBottom: '1px solid',
                                                borderBottomColor: '#f0e9ff',
                                                height: 1,
                                                width: '100%',
                                            }}
                                            className={'my-4'}
                                        ></Box>
                                    )}
                                </>
                            );
                        })}
                    </Box>
                </Grid>
            </Grid>
        </Container>
    );
};

export async function getServerSideProps(ctx) {
    const type = ctx.query.id;
    return {
        props: { type },
    };
}

NewsList.Layout = HomeLayout;

export default NewsList;
